import {
  addDriverFromTrip,
  deleteTransactionApi,
  getAccountList,
  getAllDriver,
  getDispatchedTrip,
  getTotalFreightDetais,
  getTransactionList,
  getTripTransactionDispatch,
  getUserPermissionApi,
  getUserSettingPerApi,
  paymentVoucherApi,
} from "_services";
import {
  AddBankAccount,
  AddEditMarketDriver,
  AddEditOwnDriver,
  AddFuelModal,
  AddMultiExpenseModal,
  AddOwnChargesModal,
  AddOwnClaimModal,
  AddTotalFreightModal,
  AttachedFileModal,
  BankListCanvas,
  ClaimCanvas,
  ClaimModal,
  ConfirmModalFor,
  DriverTripReport,
  FreightPayModal,
  FuelOutModal,
  OtherExpenseModal,
  OtherOwnChargesModal,
  PayDriver,
  PaymentConfirmModal,
  PaymentProcessingOffcanvas,
  PaymentStatusCard,
  PaymentSuccessOffcanvas,
  PaymentVoucher,
  SelectLrForClaimCanves,
  SupplierTripReport,
} from "modals";
import React, { useContext, useEffect, useState } from "react";
import StorageService from "utils/StorageServices/StorageServices";
import { TripReactTable } from "./TripReactTable";
import { errorSchema, utils } from "helper";
import { UserContext } from "context";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { CityDropdownForTrip, CommonInput, CustomSelect, CustomToolTip, PrintHtmlContent } from "components";
import toast from "react-hot-toast";
import { MarketDriver } from "pages/Accounts";
import images from "constants/images";
import { Images } from "constants";
import FreightAdvancePay from "modals/FreightAdvancePay/FreightAdvancePay";
import useDocumentTitle from "hooks/useDocumentTitle";
import useFetchDropdowns from "hooks/useFetchDropdowns";
import { getVoucherReport } from "_services/accountingServices/accountingServices";
import printHtmlContent from "helper/utils";
import { constant } from "constants/constant";


const Freight = ({
  freightId,
  tripDetais,
  callApi,
  userPermission,
  endTripApiCall,
}) => {
  const initiFrom = {
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: "",
    vendor_account: "",
    lr_id: "",
    trip_id: "",
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
    driver_id: "",
  };

  const intialTotal = {
    trip_id: "",
    amount: "",
    tds_diduction: "",
  };
  useDocumentTitle("Freight | T360");
  const navigate = useNavigate();
  const { masterData, globTripDetails, setBankDetails, userSettingPermission, setIsDriverName } =
    useContext(UserContext);
  const [data, setData] = useState(tripDetais);
  const [form, setForm] = useState(initiFrom);
  const [formName, setFormName] = useState(initiFrom);
  const [isOpenTotal, setIsOpenTotal] = useState(false);
  const [transactionList, setTransactionList] = useState();
  const [isOpenFreight, setIsOpenFreight] = useState({ open: false, type: "" });
  const [isOpenClaim, setIsOpenClaim] = useState(false);
  const [isOpenOwnClaim, setIsOpenOwnClaim] = useState(false);
  const [isOpenExpense, setIsOpenExpense] = useState({ open: false, type: "" });
  const [isOpenOwnExpense, setIsOpenOwnExpense] = useState({
    open: false,
    type: "",
  });
  const [isOpenFuel, setIsOpenFuel] = useState({ open: false, type: "" });
  const [canvasOpen, setCanvasOpen] = useState(false);
  const [tripChargesOpen, setTripChargesOpen] = useState(false);
  const [isOpenPayNow, setIsOpenPayNow] = useState(false);
  const [showAddBank, setShowAddBank] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [isOpenSelectLr, setIsOpenSelectLr] = useState(false);
  const [lrDetails, setLrDetails] = useState("");
  const [isOpenPayDriver, setIsOpenPayDriver] = useState(false);
  const [totalFreightDetails, setTotalFreightDetails] = useState("");
  const [driverList, setDriverList] = useState([]);
  const [driverSelect, setDriverSelect] = useState(false);
  const [showOffcanvasDriver, setShowOffcanvasDriver] = useState(false);
  const [addDriverShow, setAddDriverShow] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [transationDetails, setTransationDetails] = useState();
  const [showFuelOut, setShowFuelOut] = useState(false);
  const [driverLoading, setDriverLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showAttachedModal, setShowAttachedModal] = useState({
    open: false,
    data: [],
  });
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
  const [editData, setEditData] = useState("");
  const [initalEditData, setInitialEditData] = useState("");
  const [tripMultiExpeOpen, setTripMultiExpeOpen] = useState(false);
  const [tripReportShow, setTripReportShow] = useState(false)
  const [tripDriverReportShow, setTripDriverReportShow] = useState(false)
  const [venderDetails, setVenderDetails] = useState({
    vender_type: 0,
    vender_id: ''
    // vender_id: globTripDetails?.vehicle_ownership == 2 ? globTripDetails?.supplier_id?._id : globTripDetails?.driver_id?._id
  })
  const [formError, setFormError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({
    voucher_id: "",
    data: {}
  })
  const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);
  const [canvasKey, setCanvasKey] = useState(0);


  const [eaesbuzzId, setEaesbuzzId] = useState({
    eb_account_id: "",
    total_amount: 0
  })

  const [printLoadingId, setPrintLoadingId] = useState(null);

  const makeFirm = {
    branch_id: {
      firm_id: {
        _id: tripDetais?.firm_id?._id
      }
    },
    vehicle_id: {
      firm_id: {
        _id: tripDetais?.vehicle_firm?._id
      }
    }
  }

  const {
    fetchDriver,
  } = useFetchDropdowns(tripDetais?.vehicle_ownership, makeFirm);

  const column = [
    {
      Header: "Date",
      accessor: "freghtDate",
    },
    {
      Header: "Voucher Number",
      accessor: "FreightVoucher",
    },
    {
      Header: "Description",
      accessor: "freightCategory",
    },
    {
      Header: "Category",
      accessor: "expenseCategory",
    },
    {
      Header: "From Account",
      accessor: "freightFromAccount",
    },
    {
      Header: "To Account",
      accessor: "freightToAccount",
    },
    {
      Header: "Amount",
      accessor: "freightAmount",
    },
    {
      Header: "",
      accessor: "freightAction",
    },
  ];

  const fsatagColumn = [
    { header: "Transaction Date", accessor: "txndt" },
    { header: "Assigned", accessor: "fastag_number" },
    { header: "Description", accessor: "freightCategory" },
    { header: "Transaction ID", accessor: "txnno" },
    { header: "Opening Bal.", accessor: "tagid" },
    { header: "Type", accessor: "fastag_status" },
    { header: "Amount", accessor: "credit_debit" },

    {
      Header: "",
      accessor: "freightAction",
    },
    // { header: "Closing Bal.", accessor: "closingBal" },
    // { header: "Status", accessor: "status_dropdown" },
  ];

  const getCategoriesNames = (item) => {
    if (item?.category_type == 1) {
      return <>{item?.categories[0]?.category?.name}</>;
    }

    if (item?.category_type == 2) {
      return <>{item?.category_name}</>;
    }
  };

  const rowDataList = (data) => {
    const listArray = data?.map((item, i) => ({
      ...item,
      serial: i + 1,
      freghtDate: (
        <>
          {" "}
          <div className="_dateTbs">{utils.formatDateMonth(item?.date)}</div>
          {/* <div>{utils.formatTime(item?.updatedAt)}</div> */}
          {/* <div>Date</div> */}
        </>
      ),
      FreightVoucher: (
        <>
          <div>{item?.voucher_no ? item?.voucher_no : "-"}</div>
          {/* <div>Voucher</div> */}
          {item?.file?.length > 0 ? (
            <div
              className="anvAttach_file"
              onClick={(e) => {
                e.stopPropagation();
                setShowAttachedModal((pre) => ({
                  ...pre,
                  open: true,
                  data: item?.file,
                }));
              }}
              style={{ cursor: "pointer" }}
            >{`Attachment (${item?.file?.length ? item?.file?.length : 0
              })`}</div>
          ) : (
            <></>
          )}
        </>
      ),
      freightCategory: (
        <>
          <div className="fBold">
            
            {/* {item?.type_name}{" "} */}
            {item?.sub_type_name
              ? `${item?.sub_type_name}`
              : item?.type_name}{" "}
            {/* {item?.type_name && item?.sub_type_name ? " | " : ""}
            {item?.sub_type_name}{" "} */}
            {item?.approval_status != 0 && (
              <span
                className={`tagBxs ${item?.approval_status === 1
                  ? "pending"
                  : item?.approval_status === 2
                    ? "hold"
                    : item?.approval_status === 3
                      ? "approved"
                      : item?.approval_status === 4
                        ? "rejected"
                        : item?.approval_status === 5
                          ? "complete"
                          : ""
                  }`}
              >
                {" "}
                {masterData?.payment_approval_status[item?.approval_status]}
              </span>
            )}{" "}
            {item?.is_deleted == 2 && (
              <span
                className={`tagBxs ${item?.is_deleted == 2 ? "cancel" : ""}`}
              >
                {" "}
                Cancel
              </span>
            )}
          </div>

          <div className="_oneLine_tx">
            <CustomToolTip>
              {item?.trip?.route_name ? `${item?.trip?.route_name}` : ""}{" "}
              {item?.trip?.route_name && item?.trip?.trip_number ? " | " : ""}
              {item?.trip?.trip_number}{" "}
            </CustomToolTip>


          </div>
        </>
      ),
      freightFromAccount: (
        <>
          <div>
            {item?.from_account?.sub_category?.name
              ? item?.from_account?.sub_category?.name
              : ""}{" "}
          </div>
          <div className="fBold">
            {item?.from_account?.name ? item?.from_account?.name : ""}
          </div>
          {/* <div>From Account</div> */}
        </>
      ),
      freightToAccount: (
        <>
          {globTripDetails?.vehicle_ownership == 1 ? (
            <div className="fBold">
              {item?.to_account?.name ? item?.to_account?.name : ""}
            </div>
          ) : (
            <>
              <div className="fBold">
                {item?.to_account?.sub_category?.name
                  ? item?.to_account?.sub_category?.name
                  : ""}
              </div>
              <div className="fBold">
                {item?.to_account?.name ? item?.to_account?.name : ""}
              </div>
            </>
          )}
          {/* <div>To Account</div> */}
        </>
      ),
      freightAmount: (
        <div style={{ textAlign: "right" }}>
          {/* {item?.entries?.credit_or_debit === 2
            ? item?.entries?.debit_amount?.toFixed(2)
            : item?.entries?.credit_amount?.toFixed(2)} ₹ */}
          ₹ {item?.total_amount.toFixed(2)}
        </div>
      ),

      expenseCategory: (
        <div style={{ textAlign: "", paddingRight: "6px" }}>
          {getCategoriesNames(item)}
          {/* <div>Category</div> */}
        </div>
      ),
      decriptionText: (
        <>
          <div className="fBold">{item?.trip?.trip_number}</div>

          <div>
            {item?.trip?.route_name && item?.description ? "|" : ""}
            {item?.description
              ? `${item?.description?.length > 6
                ? item?.description.slice(0, 6) + "..."
                : item?.description
              }`
              : ""}
          </div>
        </>
      ),
      freightAction: (
        <>
          <div className="_rSide_drp">
            <div className="signDropdown">
              <button
                className="dropbtn11"
                onClick={(e) => e.stopPropagation()}

              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <rect
                    x="0.390625"
                    y="0.390625"
                    width="24.2188"
                    height="24.2188"
                    rx="2.73438"
                    stroke="#0049D7"
                    strokeWidth="0.78125"
                  />
                  <path
                    d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z"
                    fill="#0049D7"
                  />
                  <path
                    d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z"
                    fill="#0049D7"
                  />
                  <path
                    d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z"
                    fill="#0049D7"
                  />
                </svg>
              </button>
              <div className="dropdownContent">
                {/* <Link
                  // to={`/setting/user/adduser/${item?.user_id?._id}`}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <FiEdit />
                    </span>{" "}
                    Edit
                  </span>
                </Link> */}

                {item?.type != 21 && <div
                  onClick={(e) => {

                    handleDelteSubmit(item);
                    e.stopPropagation();
                  }}
                  className="_avPointer"
                >
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>{" "}
                    Delete
                  </span>
                </div>}
              </div>
            </div>
          </div>
        </>
      ),
    }));
    return listArray;
  };

  const rowListData = (data) => {
    return data?.map((item, i) => {
      // Calculate balances properly
      const openingBalance = Number(item?.balance) || 0;
      const debitAmount = Number(item?.debitamt) || 0;
      const creditAmount = Number(item?.creditamt) || 0;

      // CORRECT CALCULATION:
      // For DEBIT: Closing = Opening - Debit (money going out)
      // For CREDIT: Closing = Opening + Credit (money coming in)
      const closingBalance = item?.txntype === "D"
        ? openingBalance - debitAmount
        : openingBalance + creditAmount;

      return {
        ...item,

        addition_date: (
          // <React.Fragment>
          //     {item?.createdAt
          //         ? utils?.formatUiDateTime(item?.createdAt)
          //         : "-"}
          // </React.Fragment>
          <>  <div className="_dateTbs">{utils.formatDateMonth(item?.createdAt)}</div>

            <div>Date</div></>

        ),
        assigned_to_company: (
          <React.Fragment>
            <div className="">
              {item?.assigned_to_company
                ? item.assigned_to_company?.company
                : "+ Assign to Company"}
            </div>
          </React.Fragment>
        ),
        assigned_to_vehicle: (
          <React.Fragment>
            <div className="imgSel_box"></div>
          </React.Fragment>
        ),
        balance: (
          <React.Fragment>
            <div className="imgSel_box">
              {openingBalance ? `₹ ${openingBalance.toFixed(2)}` : "₹ 0.00"}
            </div>
          </React.Fragment>
        ),
        credit_debit: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.txntype === "D"
                ? `₹ ${debitAmount.toFixed(2)}`
                : `₹ ${creditAmount.toFixed(2)}`}
            </div>
          </React.Fragment>
        ),
        closingBal: (
          <React.Fragment>
            <div className="imgSel_box">
              ₹ {closingBalance.toFixed(2)}
            </div>
          </React.Fragment>
        ),
        fastag_tags: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.fastag_tags || "-"}
            </div>
          </React.Fragment>
        ),
        fastag_status: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.txntype === "D" ? "DEBIT" : "CREDIT"}
            </div>
          </React.Fragment>
        ),
        fastag_number: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.assigned_to_vehicle?.vehicle_no || "-"}
            </div>
            {/* <div className="__fastNumber">
              <p>{item?.tagid || "-"}</p>
            </div> */}
          </React.Fragment>
        ),
        updatedAt: (
          <React.Fragment>
            {item?.updatedAt ? utils?.formatUiDateTime(item?.updatedAt) : "-"}
          </React.Fragment>
        ),
        // status_dropdown: (
        //     <React.Fragment>
        //         <StatusDropdown
        //             value={item?.trip_relation}
        //             onChange={(newStatus) =>  item?.trip_relation != newStatus && setIsStatusChange({ isOpen: item, tag: newStatus })}
        //             options={statusOptions}
        //             size="medium"
        //             disabled={item?.txntype === "C"}
        //         />
        //     </React.Fragment>
        // ),

        tripDescription: (
          <React.Fragment>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <div style={{ fontWeight: 400, fontSize: '14px', color: '#1a1a1a' }}>
                {item?.txndetails || "-"}
              </div>
              <Link style={{ fontSize: '13px', color: '#666' }}>
                {item?.trip?.trip_number ? `Trip #${item?.trip?.trip_number}` : ""}
              </Link>
              <div style={{ fontSize: '12px', color: '#888' }}>
                {item?.trip?.route_name || ""}
              </div>
            </div>
          </React.Fragment>
        ),

        freightCategory: (
          <>
            <div className="fBold">

              {item?.txndetails
                ? `${item?.txndetails}`
                : item?.txndetails}{" "}

              {item?.is_deleted == 2 && (
                <span
                  className={`tagBxs ${item?.is_deleted == 2 ? "cancel" : ""}`}
                >
                  {" "}
                  Cancel
                </span>
              )}
            </div>

            <div className="_oneLine_tx">
              {item?.trip?.route_name ? `${item?.trip?.route_name}` : ""}{" "}
              {item?.trip?.route_name && item?.trip?.trip_number ? " | " : ""}
              {item?.trip?.trip_number}{" "}

            </div>
          </>
        ),
      };
    });
  };
  useEffect(() => {
    getTransactionListHandler(freightId);

  }, []);

  useEffect(() => {
    if (addDriverShow) {
      getDriverList();
    }
  }, [addDriverShow])

  // useEffect(() => {

  //   if (globTripDetails || venderDetails) {
  //     getAccountListHandler(
  //      globTripDetails?.vehicle_ownership == 2
  //       ? venderDetails.vendor_id ? venderDetails?.vendor_id : globTripDetails?.supplier_id?._id
  //       : venderDetails.vendor_id ? venderDetails?.vendor_id : globTripDetails?.driver_id?._id
  //     );
  //   }
  // }, [globTripDetails,venderDetails]);

  useEffect(() => {
    if (venderDetails?.vender_id) {

      getAccountListHandler(
        venderDetails
      );
    }
  }, [venderDetails]);


  useEffect(() => {
    if (transationDetails) {
      setConfirmModalShow(true);
    }
  }, [transationDetails]);

  useEffect(() => {
    if (endTripApiCall === "call") {
      callbackTotal();
    }
  }, [endTripApiCall]);

  const handleDelteSubmit = (i) => {
    setTransationDetails(i);
  };

  const callbackTotal = () => {
    getDispatchedTripHandler(freightId);
    getTransactionListHandler(freightId);
    callApi();
  };

  const getDispatchedTripHandler = async (tripId) => {
    try {
      const res = await getDispatchedTrip({
        company_id: StorageService.getCompanyId(),
        trip_id: tripId,
      });

      if (res?.responseCode === 200) {
        setData(res?.data?.trip);
      } else {
      }
    } catch (error) {
    }
  };

  const getTransactionListHandler = async (freightId) => {
    try {
      const res = await getTripTransactionDispatch({
        company_id: StorageService.getCompanyId(),
        trip_id: freightId,
      });

      if (res?.responseCode === 200) {
        setTransactionList(res?.data);
      } else {
      }
    } catch (error) {
    }
  };

  const getTotalDetails = async (freightId) => {
    try {
      const res = await getTotalFreightDetais({
        company_id: StorageService.getCompanyId(),
        trip_id: freightId,
      });

      if (res?.responseCode === 200) {
        setTotalFreightDetails(res?.data?.trip?.freight_summary);
      } else {
      }
    } catch (error) {
    }
  };

  const getAccountListHandler = async (venderDetailsPara) => {
    try {
      const res = await getAccountList({
        company_id: StorageService?.getCompanyId(),
        vendor_type: venderDetailsPara?.vender_type,
        vendor_id: venderDetailsPara?.vender_id,
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.bank_account?.map((item) => {
          return {
            ...item,
            label: item?.bank_name,
            value: item?._id,
          };
        });
        setAccountList(details);
      } else {
      }
    } catch (error) {
    }
  };

  const getDriverList = async () => {
    const res = await getAllDriver({
      company_id: StorageService.getCompanyId(),
      offset: 1,
      limit: 2000,

    });
    if (res?.responseCode === 200) {
      setDriverList(
        res?.data?.driver_list
          ?.filter((i) => i?.driver_type == 2)
          ?.map((i) => {
            return {
              ...i,
              label: i.name,
              value: i._id,
            };
          })
      );
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const calBackOpen = (title, open) => {
    if (title === "freight") {
      setIsOpenFreight({ open: open, type: "freight" });
    }
    if (title === "freightBalance") {
      setIsOpenFreight({ open: open, type: "freightBalance" });
    }
    if (title === "claim") {
      setIsOpenSelectLr(open);
    }
    if (title === "claimOwn") {
      setIsOpenSelectLr(open);
    }
    if (title === "Charges") {
      setTripChargesOpen(open);
    }
    if (title === "expense") {
      setIsOpenExpense({ open: open, type: "expense" });
    }
    if (title === "receipt") {
      setIsOpenExpense({ open: open, type: "receipt" });
    }
    if (title === "ownexpense") {
      setIsOpenOwnExpense({ open: open, type: "expense" });
    }
    if (title === "ownreceipt") {
      setIsOpenOwnExpense({ open: open, type: "receipt" });
    }
    if (title === "fuel_supplier") {
      setIsOpenFuel({ open: true, type: "fuel_supplier" });
    }
    if (title === "fuel_driver") {
      setIsOpenFuel({ open: true, type: "fuel_driver" });
    }
    if (title === "payDriver") {
      setIsOpenPayDriver(true);
    }
    if (title === "totalFreight") {
      getTotalDetails(freightId);
      setIsOpenTotal(true);
    }

    if (title === "multi_expense") {
      setTripMultiExpeOpen(open);
    }
  };

  const callBackAddAccount = () => {
    setCanvasOpen(true);
    getAccountListHandler(venderDetails);
  }

  const callBackFreight = () => {
    getTransactionListHandler(freightId);
    callApi();
  };

  const callBackTransaction = () => {
    getTransactionListHandler(freightId);
  }
  const callClaim = (Details) => {
    if (data?.vehicle_ownership === 2) {
      setIsOpenClaim(true);
    } else {
      setIsOpenOwnClaim(true);
    }

    setLrDetails(Details);
  };

  const addDriverHandle = (data) => {
    setAddDriverShow(false);
    setShowOffcanvasDriver(true);
  };

  const callBackDriver = async (data) => {
    setAddDriverShow(true);
    setForm({ ...form, driver_id: { ...data, label: data?.name, value: data?._id } });
    if (formError?.driver_id) {
      setFormError({ ...formError, driver_id: null });
    }
    // getDriverList();
    // callApi();
  };

  const callBackFuelOut = () => {
    getTransactionListHandler(freightId);
    callApi();
  };

  const handleAddDriver = async () => {
    const validationResult = await utils.checkFormError(
      { ...form, driver_id: form?.driver_id?._id },
      errorSchema.addMarketDriver
    );
    if (validationResult == true) {
      try {
        setDriverLoading(true);
        const payload = {
          company_id: StorageService?.getCompanyId(),
          trip_id: globTripDetails?._id,
          driver_id: form?.driver_id?._id,
          is_existing_driver: 1
        };

        const res = await addDriverFromTrip(payload);

        if (res?.responseCode == 200) {
          toast.success(res?.responseMessage);
          getTransactionListHandler(freightId);
          callApi();
          setAddDriverShow(false);
          setDriverLoading(false);
        } else {
          setDriverLoading(false);
          toast.error(res?.responseMessage);
        }
      } catch (error) {
        setDriverLoading(false);
        toast.error(error?.message);
      }
    } else {
      setFormError(validationResult)
    }

  };
  const handleDelete = async () => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: transationDetails?.transaction_id || paymentVoucherOpen?.transaction_id,
    };
    try {
      setDeleteLoading(true);
      const res = await deleteTransactionApi(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setConfirmModalShow(false);
        setTransationDetails("");
        getTransactionListHandler(freightId);
        setPaymentVoucherOpen(false)
        callApi();
        setDeleteLoading(false);
      } else {
        setDeleteLoading(false);
        // toast.error(res?.responseMessage);
      }
    } catch (error) {
      setDeleteLoading(false);
      toast.error(error?.message);
    }
  };

  const callBackPayment = async (data) => {
    setPaymentVoucherOpen(data);
  };

  const venderDetailsFun = (data) => {

    setVenderDetails(data)
  }


  const paymentResult = (data, voucher_id) => {
    callBackFreight()
    setIsProcessing(false);
    setIsOpenPayNow(false)
    setIsOpenFreight({ ...isOpenFreight, open: false, type: "" })
    setIsOpenPayDriver(false)
    setIsOpenExpense({ ...isOpenExpense, open: false, type: "" })
    setIsMakeStatusOpen(true);
    setPaymentData({
      voucher_id: voucher_id,
      data: data
    })
    setCanvasKey(prev => prev + 1);
  }

  const callbackEaesbuzz = (id, amount, venderDetails, payload) => {

    setEaesbuzzId((pre) => ({
      ...pre, eb_account_id: id,
      total_amount: amount,
      vendor_bank_account: venderDetails?.vendor_bank_account,
      payload: payload
    }))
  }

  const onShareReceipt = () => {

  }

  const viewReceiptHandle = (data) => {
    setIsSuccessOpen(data)
  }

  const doneHandle = () => {
    callBackFreight()
    setIsOpenFreight({ ...isOpenFreight, open: false, type: "" })
    setIsOpenOwnExpense({ ...isOpenOwnExpense, open: false, type: "" })
    setTripChargesOpen(false)
    setIsOpenPayNow(false)
    setIsMakeStatusOpen(false)
  }


  const handleDownloadReceipt = async () => {
    try {
      const response = await fetch(`/api/receipt/${paymentData?.transactionId}`);
      const blob = await response.blob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `receipt_${paymentData?.transactionId}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      alert('Failed to download receipt');
    }
  };

  const handlePrintDownload = async (voucherId) => {
    try {
      setPrintLoadingId(voucherId);

      const res = await getVoucherReport({
        company_id: StorageService?.getCompanyId(),
        voucher_id: voucherId,
      });

      printHtmlContent({
        html: res,
        title: `Bilty-${voucherId}`,
        onAfter: () => setPrintLoadingId(false),
      });

    } catch (err) {
      console.error('Print error:', err);
      setPrintLoadingId(false);
    }
  };

  let attachedModal = {
    isOpen: showAttachedModal?.open,
    closeModal: (e) =>
      setShowAttachedModal((pre) => ({ ...pre, open: false, data: [] })),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _AttachmentModal",
    modalTitle: "Attachment",
    submitTitle: "Add",
    cancelButtonTitle: "Cancel",
    showAttachedModal: showAttachedModal,
    // getMaterial: (e) => getMaterial()
    // getBanner: (e) => getBanner()
  };

  let addTotalProps = {
    isOpen: isOpenTotal,
    closeModal: (e) => {
      setIsOpenTotal(false);
      setTotalFreightDetails("");
    },
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle:
      totalFreightDetails || editData
        ? "Update Total Freight"
        : "Add Total Freight",
    submitTitle:
      totalFreightDetails || editData ? "Update" : "Add Total Freight",
    editData: editData,
    tripId: freightId,
    callbackTotal: callbackTotal,
    userPermission: userPermission?.supplier_freight,
    totalFreightDetails: totalFreightDetails,
  };

  let freightpayProps = {
    isOpen: isOpenFreight?.open,
    isOpenFreight: isOpenFreight,
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    modalType: isOpenExpense.type,
    closeModal: (e) =>
      setIsOpenFreight({ ...isOpenFreight, open: false, type: "" }),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Freight",
    submitTitle: "Add Freight",
    cancelButtonTitle: "Send for Approval",
    tripId: freightId,
    callBackFreight: callBackFreight,
    transactionList: transactionList,
    accountList: accountList,
    setIsOpenFreight: setIsOpenFreight,
    userPermission: userPermission?.supplier_freight,
    userSettingPermission: userSettingPermission,
    venderDetailsFun: venderDetailsFun,
    tripDetais: transactionList?.trip_detail,
    setIsOpenPayNow,
    callbackEaesbuzz,
    key: canvasKey
  };

  const closeClaimModal = () => {
    setIsOpenClaim(false);
    setIsOpenOwnClaim(false);
    setBankDetails("");
  };
  let claimProps = {
    isOpen: isOpenClaim,
    closeModal: closeClaimModal,
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Claim Payable to Supplier ",
    submitTitle: "Continue",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackFreight: callBackFreight,
    transactionList: transactionList,
    accountList: accountList,
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    userPermission: userPermission?.supplier_freight,
  };

  const payDriverProps = {
    isOpen: isOpenPayDriver,
    closeModal: () => setIsOpenPayDriver(false),
    headerPart: false,
    footerPart: true,
    modalTitle: "Pay Driver",
    tripId: freightId,
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    accountList: accountList,
    callBackFreight: callBackFreight,
    venderDetailsFun: venderDetailsFun,
    tripDetais: transactionList?.trip_detail,
    setIsOpenPayNow,
    callbackEaesbuzz
  };

  let otherExpenseProps = {
    isOpen: isOpenExpense.open,
    modalType: isOpenExpense.type,
    closeModal: (e) =>
      setIsOpenExpense({ ...isOpenExpense, open: false, type: "" }),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Other",
    submitTitle: "Save",
    tripId: freightId,
    callBackFreight: callBackTransaction,
    transactionList: transactionList,
    userPermission: userPermission?.other,
    userSettingPermission: userSettingPermission,
    accountList: accountList,
    setCanvasOpen: setCanvasOpen,
    venderDetailsFun: venderDetailsFun,
    tripDetais: transactionList?.trip_detail,
    setIsOpenPayNow,
    callbackEaesbuzz
  };

  let fuelProps = {
    isOpen: isOpenFuel,
    closeModal: (e) => setIsOpenFuel({ ...isOpenFuel, open: false, type: "" }),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Fuel",
    submitTitle: "Save",
    tripId: freightId,
    callBackFreight: callbackTotal,
    transactionList: transactionList,
    userSettingPermission: userSettingPermission,
    tripDetais: transactionList?.trip_detail
  };

  let bankListProps = {
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,
    setShowAddBank: setShowAddBank,
    accountList: accountList,
    setIsOpenFreight: setIsOpenFreight,
    venderDetails: venderDetails
  };

  const accountClose = () => {
    setShowAddBank(false);
    setCanvasOpen(true);
  };

  let firstAddBank = {
    isOpen: showAddBank,
    closeModal: accountClose,
    headerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Bank Account",
    submitTitle: "Continue",
    callBackAddAccount: callBackAddAccount,
    venderDetails: venderDetails
  };

  let selectLrProps = {
    isOpen: isOpenSelectLr,
    closeModal: (e) => setIsOpenSelectLr(false),
    tripId: freightId,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Select LR to Claim",
    submitTitle: "Continue",
    callClaim: callClaim,
  };

  //---------------- own Props -----------

  let chargesProps = {
    isOpen: tripChargesOpen,
    closeModal: () => setTripChargesOpen(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Trip Charges ",
    submitTitle: "",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackFreight: callBackFreight,
    transactionList: transactionList,
    accountList: accountList,
    userSettingPermission: userSettingPermission,
    venderDetailsFun: venderDetailsFun,
    tripDetais: transactionList?.trip_detail,
    setCanvasOpen: setCanvasOpen,
    setIsOpenPayNow,
    callbackEaesbuzz
  };

  let ownclaimProps = {
    isOpen: isOpenOwnClaim,
    closeModal: closeClaimModal,
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    submitTitle: "Continue",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackFreight: callBackFreight,
    transactionList: transactionList,
    accountList: accountList,
    setCanvasOpen: setCanvasOpen,
    canvasOpen: canvasOpen,

  };

  let otherOwnExpenseProps = {
    isOpen: isOpenOwnExpense.open,
    modalType: isOpenOwnExpense.type,
    closeModal: (e) =>
      setIsOpenOwnExpense({ ...isOpenOwnExpense, open: false, type: "" }),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Other",
    submitTitle: "Save",
    tripId: freightId,
    callBackFreight: callBackTransaction,
    transactionList: transactionList,
    userSettingPermission: userSettingPermission,
    accountList: accountList,
    setCanvasOpen: setCanvasOpen,
    venderDetailsFun: venderDetailsFun,
    tripDetais: transactionList?.trip_detail,
    setIsOpenPayNow,
    callbackEaesbuzz
  };

  useEffect(() => {
    if (
      globTripDetails?.vehicle_ownership == 2 &&
      data?.freight_summary?.total_freight == 0
    ) {
      setIsOpenTotal(true);
    }
  }, [data?.freight_summary?.total_freight]);

  let addDriverprops = {
    show: addDriverShow,
    closeModal: (e) => setAddDriverShow(false),
    title: "Select Driver",
    submitTitle: "Add",
    onSubmit: handleAddDriver,
    icon: images.EDIT,
    isLoadding: driverLoading,
    disabled: driverLoading,
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => {
      setConfirmModalShow(false);
      setTransationDetails("");
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading,
  };

  let fuelOutProps = {
    isOpen: showFuelOut,
    closeModal: (e) => {
      setShowFuelOut(false);
    },
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Fuel Out",
    submitTitle: "Fuel Out",
    callBackEnd: callBackFuelOut,
    // lastTripDetails: lastTripDetails,
    endTripFrom: "Trip",
    transactionList: transactionList,
    availableFuel: globTripDetails?.vehicle_id?.available_fuel
  };

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?._id,
    oprnDeleteModal: setConfirmModalShow,
    onPrintHandle: handlePrintDownload,
    printLoadingId
  };

  let multiExpenseProps = {
    isOpen: tripMultiExpeOpen,
    closeModal: () => setTripMultiExpeOpen(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Trip Charges ",
    submitTitle: "",
    tripId: freightId,
    lrDetails: lrDetails,
    callBackFreight: callBackFreight,
    transactionList: transactionList,
    accountList: accountList,
    userSettingPermission: userSettingPermission,
    tripDetais: transactionList?.trip_detail,
    setIsOpenPayNow,
    callbackEaesbuzz,
    setCanvasOpen: setCanvasOpen,
    venderDetailsFun

  };

  let TripReoprtModal = {
    isOpen: tripReportShow,
    closeModal: (e) => setTripReportShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Supplier Trip",
    submitTitle: "Download",
    therdSubmitTitle: "Download",
    freightId: freightId,
  }

  let driverTripReoprtPrps = {
    isOpen: tripDriverReportShow,
    closeModal: (e) => setTripDriverReportShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Driver Trip Report",
    submitTitle: "Download",
    therdSubmitTitle: "Download",
    freightId: freightId,
    tripDetais: tripDetais,

  }

  let payNowProps = {
    isOpen: isOpenPayNow,
    closeModal: (e) => setIsOpenPayNow(false),
    setIsProcessing, setIsProcessing,
    setIsOpenPayNow: setIsOpenPayNow,
    easebuzzDetails: eaesbuzzId
  }

  return (
    <div className="anv_tripTab_otr">
      <div className="row anvRG_gap">
        <div className="col-12">
          <div className="anvFrightUpp_tabBx_tp">
            <div className="anvFrightInden_detailBx_tp">
              <div className="sprt_dix _nwDix_sprt">
                <div className="_anvFix_bs">
                  <p>
                    Tyres{" "}
                    {`${data?.lorry_type_id?.lorry_type
                      ? data?.lorry_type_id?.lorry_type
                      : ""
                      } > ${data?.vehicle_type_id?.name
                        ? data?.vehicle_type_id?.name
                        : ""
                      }`}
                  </p>
                  <h2>
                    {data?.vehicle_id?.vehicle_no && (
                      <>
                        {data?.vehicle_id?.vehicle_no.length === 9
                          ? // Case when length is 9, middle part is one digit
                          data?.vehicle_id?.vehicle_no.slice(0, 4) +
                          " " +
                          data?.vehicle_id?.vehicle_no.slice(4, 5) +
                          " " +
                          data?.vehicle_id?.vehicle_no.slice(5)
                          : // Case when length is 10, middle part is two digits
                          data?.vehicle_id?.vehicle_no.slice(0, 4) +
                          " " +
                          data?.vehicle_id?.vehicle_no.slice(4, 6) +
                          " " +
                          data?.vehicle_id?.vehicle_no.slice(6)}{" "}
                        <span
                          className={
                            data?.vehicle_ownership === 1
                              ? "_trkMark _lrDelivered_status"
                              : data?.vehicle_ownership === 2
                                ? "_trkMark _lrPartyPoint_status"
                                : "_trkMark _lrInTransit_status"
                          }
                        >
                          {
                            masterData?.vehicle_ownership_list?.find(
                              (i) => i.id === data?.vehicle_ownership
                            )?.name
                          }
                        </span>
                      </>
                    )}
                  </h2>
                </div>
              </div>
              {globTripDetails?.vehicle_ownership == 2 && (
                <>
                  {data?.supplier_id?.name && (
                    <div className="sprt_dix _nwDix_sprt">
                      <div className="_anvFix_bs">
                        {/* <p>Supplier</p> */}
                        <h3
                          onClick={() =>
                            navigate(
                              
                              `/account/supplier/details/${data?.supplier_id?._id}?type=${constant.m_type.supplier}&tab=${1}&search=${data?.supplier_id?.name}&offset=${1}&total_record=${25}&is_list=${true}`
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {data?.supplier_id?.name}
                        </h3>

                        {/* Change Class For Positive Balance */}
                        <div
                          className={
                            data?.supplier_id?.balance >= 0
                              ? "_positiveBal_btn"
                              : "_negativeBal_btn"
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              `/account/supplier/details/${data?.supplier_id?._id}?type=${constant.m_type.supplier}&tab=${4}&search=${data?.supplier_id?.name}&offset=${1}&total_record=${25}&is_list=${true}`
                            )
                          }
                        >
                          <span>Balance</span>
                          <span className={"_blAmt"}>
                            {" "}
                            {`₹ ${data?.supplier_id?.balance >= 0
                              ? `${globTripDetails?.supplier_id?.balance?.toFixed(
                                2
                              )}`
                              : `${globTripDetails?.supplier_id?.balance?.toFixed(
                                2
                              )}`
                              }`}
                          </span>
                        </div>
                      </div>

                      {tripDetais?.trip_status != 5 && <button
                        className="__vw_sxBtn"
                        onClick={() =>
                          navigate(
                            `/account/supplier/details/${data?.supplier_id?._id}?tab=1`
                          )
                        }
                      >
                        View
                      </button>}

                      {/* Change Class For Negative Balance */}
                      {/* <div className="_negativeBal_btn"><span>Balance</span><span className="_blAmt"> ₹ 50000</span></div> */}
                    </div>
                  )}
                </>
              )}
              {globTripDetails?.driver_id?.name &&
                (globTripDetails?.vehicle_ownership == 1 || globTripDetails?.vehicle_ownership == 3) && (
                  <div className="sprt_dix _nwDix_sprt">
                    <div className="_anvFix_bs">
                      {/* <p>Supplier</p> */}
                      <h3
                        onClick={() => {
                          setIsDriverName(data?.driver_id?.name)
                          navigate(
                            `/account/driver/details/${data?.driver_id?._id}?type=${constant.m_type.own_driver}&tab=${2}&search=${data?.driver_id?.name}&offset=${1}&total_record=${25}&driver_type=${1}&is_list=${true}`
                            
                          )
                        }
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {globTripDetails?.driver_id?.name
                          ? globTripDetails?.driver_id?.name
                          : "No Driver name"}
                      </h3>

                      {/* Change Class For Positive Balance */}
                      <div
                        className={
                          globTripDetails?.driver_id?.balance >= 0
                            ? "_positiveBal_btn"
                            : "_negativeBal_btn"
                        }
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsDriverName(data?.driver_id?.name)
                          navigate(
                            `/account/driver/details/${data?.driver_id?._id}?type=${constant.m_type.own_driver}&tab=${2}&search=${data?.driver_id?.name}&offset=${1}&total_record=${25}&driver_type=${1}&is_list=${true}`
                            // `/account/driver/details/${data?.driver_id?._id}?tab=2`
                            // , {
                            //   state: {
                            //     data: { driver: "own", type: 2, name: data?.driver_id?.name },
                            //   },
                            // }
                          )
                        }
                        }
                      >
                        <span>Balance</span>
                        <span className={"_blAmt"}>
                          {" "}
                          {`₹ ${globTripDetails?.driver_id?.balance >= 0
                            ? `${globTripDetails?.driver_id?.balance?.toFixed(
                              2
                            )}`
                            : `${globTripDetails?.driver_id?.balance?.toFixed(
                              2
                            )}`
                            }`}
                        </span>
                      </div>
                    </div>

                    {tripDetais?.trip_status != 5 && <button
                      className="__vw_sxBtn"
                      onClick={() => calBackOpen("payDriver", true)}
                    >
                      Pay Driver
                    </button>}

                    {/* Change Class For Negative Balance */}
                    {/* <div className="_negativeBal_btn"><span>Balance</span><span className="_blAmt"> ₹ 50000</span></div> */}
                  </div>
                )}

              {globTripDetails?.vehicle_ownership == 2 && (
                <>
                  {!globTripDetails?.driver_id?.name ? (
                    <div className="sprt_dix _nwDix_sprt">
                      <div className="_anvFix_bs">
                        {/* <p>Market Driver</p> */}
                        <h3
                          // onClick={() => navigate(`/account/supplier/details/${data?.supplier_id?._id}?tab=1`)}
                          style={{ cursor: "pointer" }}
                        >
                          No Driver Added
                        </h3>

                        <div className="_negativeBal_btn">
                          <span>
                            {
                              masterData?.vehicle_ownership_list?.find(
                                (i) =>
                                  i.id === globTripDetails?.vehicle_ownership
                              )?.name
                            }{" "}
                            Driver
                          </span>
                        </div>
                      </div>
                      {tripDetais?.trip_status != 5 && <button
                        className="__vw_sxBtn"
                        onClick={() => setAddDriverShow(true)}
                      >
                        Add
                      </button>}
                    </div>
                  ) : (
                    <div className="sprt_dix _nwDix_sprt">
                      <div className="_anvFix_bs">
                        {/* <p>Market Driver</p> */}
                        <h3
                          onClick={() =>
                            navigate(
                              `/account/driver/details/${globTripDetails?.driver_id?._id}`,
                              {
                                state: {
                                  data: { driver: "market", type: 1 }
                                },
                              }
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {globTripDetails?.driver_id?.name
                            ? globTripDetails?.driver_id?.name
                            : "No Driver name"}
                        </h3>

                        <div className="_negativeBal_btn">
                          <span>Market Driver</span>
                        </div>
                      </div>
                      <button
                        className="__vw_sxBtn"
                        onClick={() =>
                          navigate(
                            `/account/driver/details/${globTripDetails?.driver_id?._id}`, {
                            state: {
                              data: { driver: "market", type: 1 }
                            },
                          }
                          )

                        }
                        style={{ cursor: "pointer" }}
                      >
                        view
                      </button>
                    </div>
                  )}
                </>
              )}

              {(globTripDetails?.vehicle_ownership === 1 ||
                globTripDetails?.vehicle_ownership === 3) && (
                  <div className="sprt_dix _nwDix_sprt">
                    <div className="_anvFix_bs">
                      {/* <p>Market Driver</p> */}
                      <h3
                        onClick={() =>
                          navigate(
                            `/account/vehicle/details/${globTripDetails?.vehicle_id?._id}?tab=3`
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Available Fuel
                      </h3>

                      <div className="_negativeBal_btn">
                        <span>Balance</span>
                        <span className={"_blAmt"}>
                          {globTripDetails?.vehicle_id
                            ? globTripDetails?.vehicle_id?.available_fuel?.toFixed(
                              2
                            )
                            : 0}{" "}
                          Ltr
                        </span>
                      </div>
                    </div>

                    {tripDetais?.trip_status != 5 && <div className="d-flex gap-2">
                      <button
                        className="__vw_sxBtn"
                        onClick={() => calBackOpen("fuel_driver", true)}
                      >
                        Pay Fuel
                      </button>
                      <button
                        className="__vw_sxBtn"
                        onClick={() => setShowFuelOut(true)}
                      >
                        Fuel Out
                      </button>
                    </div>}
                  </div>
                )}

              {/* {<div className="sprt_dix _nwDix_sprt">
                {driverSelect && 
                            <div className="_divForth">
                              <CustomSelect
                                label="Driver"
                                placeholder="Select Driver"
                                options={
                                  driverList
                                    ? driverList
                                    : [{ label: "Select ", value: "123" }]
                                }
                                onSelect={(data) => {
                                  setForm({...form,driver_id:data?._id})
                                
                                }}
                                value={driverList?.find((i)=>i?._id==form?.driver_id)}
                                isAddButton={true}
                                addButtonAction={addDriverHandle}
                                // error={formError.driver_id}
                              />
                            </div>
                          }
              </div>} */}
            </div>
          </div>
        </div>

        <div className="col-12">
          {data?.vehicle_ownership === 2 &&
            data?.freight_summary?.total_freight == 0 ? (
            <div className="_addSingleBrr">
              <button
                className="addAble_btn addClaim"
                onClick={() => setIsOpenTotal(true)}
              >
                <div className="_otrIcon_imb">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.5 18.3091H3.5C2.57174 18.3091 1.6815 17.9404 1.02513 17.284C0.368749 16.6276 0 15.7374 0 14.8091V1.75212C0 0.685123 1.056 0.00812271 1.985 0.330123C2.118 0.376123 2.248 0.443123 2.372 0.532123L2.547 0.657123C2.97266 0.95915 3.48188 1.12098 4.0038 1.12008C4.52572 1.11918 5.03438 0.95561 5.459 0.652123C6.05504 0.227937 6.76843 0 7.5 0C8.23157 0 8.94496 0.227937 9.541 0.652123C9.96562 0.95561 10.4743 1.11918 10.9962 1.12008C11.5181 1.12098 12.0273 0.95915 12.453 0.657123L12.628 0.532123C13.621 -0.177877 15 0.532123 15 1.75212V9.30912H18.5C18.6989 9.30912 18.8897 9.38814 19.0303 9.52879C19.171 9.66945 19.25 9.86021 19.25 10.0591V15.5591C19.25 16.2885 18.9603 16.9879 18.4445 17.5037C17.9288 18.0194 17.2293 18.3091 16.5 18.3091ZM15.25 10.8091V15.5591C15.25 15.8906 15.3817 16.2086 15.6161 16.443C15.8505 16.6774 16.1685 16.8091 16.5 16.8091C16.8315 16.8091 17.1495 16.6774 17.3839 16.443C17.6183 16.2086 17.75 15.8906 17.75 15.5591V10.8091H15.25ZM11 6.55912C11 6.36021 10.921 6.16945 10.7803 6.02879C10.6397 5.88814 10.4489 5.80912 10.25 5.80912H4.25C4.05109 5.80912 3.86032 5.88814 3.71967 6.02879C3.57902 6.16945 3.5 6.36021 3.5 6.55912C3.5 6.75804 3.57902 6.9488 3.71967 7.08945C3.86032 7.2301 4.05109 7.30912 4.25 7.30912H10.25C10.4489 7.30912 10.6397 7.2301 10.7803 7.08945C10.921 6.9488 11 6.75804 11 6.55912ZM10 9.55912C10 9.36021 9.92098 9.16945 9.78033 9.02879C9.63968 8.88814 9.44891 8.80912 9.25 8.80912H4.25C4.05109 8.80912 3.86032 8.88814 3.71967 9.02879C3.57902 9.16945 3.5 9.36021 3.5 9.55912C3.5 9.75804 3.57902 9.9488 3.71967 10.0895C3.86032 10.2301 4.05109 10.3091 4.25 10.3091H9.25C9.44891 10.3091 9.63968 10.2301 9.78033 10.0895C9.92098 9.9488 10 9.75804 10 9.55912ZM10.25 11.8091C10.4489 11.8091 10.6397 11.8881 10.7803 12.0288C10.921 12.1694 11 12.3602 11 12.5591C11 12.758 10.921 12.9488 10.7803 13.0895C10.6397 13.2301 10.4489 13.3091 10.25 13.3091H4.25C4.05109 13.3091 3.86032 13.2301 3.71967 13.0895C3.57902 12.9488 3.5 12.758 3.5 12.5591C3.5 12.3602 3.57902 12.1694 3.71967 12.0288C3.86032 11.8881 4.05109 11.8091 4.25 11.8091H10.25Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <span>Add total Freight</span>
              </button>
            </div>
          ) : (
            transactionList?.freight_summary && (
              <div className="anv_freightTable_otr_tpBx">
                <div className="anv_freightTable_detail_tpBx">
                  <div className="container_table rowGaper4">
                    <div className="__nW_tblSpx">
                      <div className="anv_fr_detailHead">
                        <h4>
                          {data?.vehicle_ownership === 2
                            ? "Total Freight"
                            : "Total Truck Expenses"}{" "}
                          <span className="__rtAmt">
                            {data?.vehicle_ownership === 2 ? (
                              <button
                                className="_numEdits_btn"
                                onClick={() => {
                                  if (tripDetais?.trip_status != 5) {
                                    setEditData(transactionList?.freight_summary);
                                    setInitialEditData(
                                      transactionList?.freight_summary
                                    );
                                    setIsOpenTotal(true);
                                  }

                                }}
                              >
                                <span
                                  className={
                                    transactionList?.freight_summary
                                      ?.total_freight >= 0
                                      ? "greenFont_cls"
                                      : "redFont_cls"
                                  }
                                >
                                  {" "}
                                  ₹{" "}
                                  {/* {transactionList?.freight_summary?.total_freight?.toFixed(
                                    2
                                  )}{" "} */}
                                  {Number(transactionList?.freight_summary?.total_freight || 0).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </span>
                                {tripDetais?.trip_status != 5 && <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="17"
                                  viewBox="0 0 17 17"
                                  fill="none"
                                >
                                  <path
                                    d="M3.64706 4.52942H2.76471C2.29668 4.52942 1.84782 4.71534 1.51687 5.04629C1.18592 5.37724 1 5.8261 1 6.29413V14.2353C1 14.7033 1.18592 15.1522 1.51687 15.4831C1.84782 15.8141 2.29668 16 2.76471 16H10.7059C11.1739 16 11.6228 15.8141 11.9537 15.4831C12.2847 15.1522 12.4706 14.7033 12.4706 14.2353V13.353"
                                    stroke="#0049D7"
                                    strokeWidth="1.76469"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.5881 2.7648L14.2352 5.41186M15.4572 4.16333C15.8047 3.81582 16 3.34449 16 2.85304C16 2.36158 15.8047 1.89025 15.4572 1.54274C15.1097 1.19523 14.6384 1 14.1469 1C13.6555 1 13.1841 1.19523 12.8366 1.54274L5.41162 8.94128V11.5883H8.05868L15.4572 4.16333Z"
                                    stroke="#0049D7"
                                    strokeWidth="1.76469"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>}
                              </button>
                            ) : (
                              <span
                                className={
                                  transactionList?.freight_summary
                                    ?.total_freight >= 0
                                    ? "greenFont_cls"
                                    : "redFont_cls"
                                }
                              >
                                {" "}
                                ₹{" "}
                                {transactionList?.freight_summary?.total_freight?.toFixed(
                                  2
                                )}{" "}

                              </span>
                            )}
                          </span>
                        </h4>

                        {data?.vehicle_ownership === 2 ? (
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.advance_freight?.length
                                ? transactionList?.advance_freight
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="freight"
                            freghtDetails={data}
                            totalFreight={transactionList?.freight_summary?.freight_summary?.balance?.toFixed(
                              2
                            )}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        ) : (
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.trip_charges?.length
                                ? transactionList?.trip_charges
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="tripCharge"
                            freghtDetails={data}
                            totalFreight={transactionList?.freight_summary?.freight_summary?.balance?.toFixed(
                              2
                            )}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        )}

                        {data?.vehicle_ownership != 2 && (
                          <TripReactTable
                            columns={fsatagColumn}
                            data={rowListData(
                              transactionList?.fastags?.length
                                ? transactionList?.fastags
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="Fastag"
                            freghtDetails={data}
                            calBackOpen={() => { }}
                            callBackPayment={() => { }}
                            totalFreight={transactionList?.freight_summary?.freight_summary?.fastag?.toFixed(
                              2
                            )}
                          />
                        )}

                        {data?.vehicle_ownership === 2 ? (
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.claims?.length
                                ? transactionList?.claims
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="supplierClaim"
                            freghtDetails={data}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        ) : (
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.claims?.length
                                ? transactionList?.claims
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="DriverClaims"
                            freghtDetails={data}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        )}
                        {data?.vehicle_ownership === 2 && (
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.balance_freight?.length
                                ? transactionList?.balance_freight
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="BalanceFreight"
                            freghtDetails={data}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        )}
                        {/* {data?.vehicle_ownership === 2 && (
                        <TripReactTable
                          columns={column}
                          data={rowDataList(
                            transactionList?.tds?.length
                              ? transactionList?.tds
                              : []
                          )}
                          transactionList={transactionList}
                          tableTitle="tds"
                          freghtDetails={data}
                          calBackOpen={calBackOpen}
                        />
                      )} */}

                        {data?.vehicle_ownership === 2 && (
                          <h4 style={{ borderBottom: "1px solid #d9e6ef" }}>
                            Balance{" "}
                            <span
                              className={
                                transactionList?.freight_summary?.balance >= 0
                                  ? "greenFont_cls"
                                  : "redFont_cls"
                              }
                            >
                              {" "}
                              ₹{" "}
                              {/* {transactionList?.freight_summary?.balance?.toFixed(
                                2
                              )}{" "} */}
                              {Number(transactionList?.freight_summary?.balance || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                            {/* <span className="__rtAmt">
                            {transactionList?.freight_summary?.balance?.toFixed(
                              2
                            )}
                          </span>{" "} */}
                          </h4>
                        )}
                      </div>
                    </div>

                    <div className="__nW_tblSpx">
                      <div className="anv_fr_detailHead">
                        <div className="mt-3">
                          <TripReactTable
                            columns={column}
                            data={rowDataList(
                              transactionList?.other_charges?.length
                                ? transactionList?.other_charges
                                : []
                            )}
                            transactionList={transactionList}
                            tableTitle="receipt"
                            freghtDetails={data}
                            calBackOpen={calBackOpen}
                            callBackPayment={callBackPayment}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {data?.vehicle_ownership === 2 ? (
                  <>
                    <div className="anvFreight_smry_tpBx">
                      <div className="anvFreight_smrySticky">
                        <h2 style={{ minHeight: "44px" }}>
                          Freight Summary{" "}

                          <div className="_rSideBtn" >
                            <button className="anime-btn _addComm_btn _builtyPrintBtn" onClick={() => setTripReportShow(true)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="19"
                                viewBox="0 0 20 19"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M16.5 18.3091H3.5C2.57174 18.3091 1.6815 17.9404 1.02513 17.284C0.368749 16.6276 0 15.7374 0 14.8091V1.75212C0 0.685123 1.056 0.00812271 1.985 0.330123C2.118 0.376123 2.248 0.443123 2.372 0.532123L2.547 0.657123C2.97266 0.95915 3.48188 1.12098 4.0038 1.12008C4.52572 1.11918 5.03438 0.95561 5.459 0.652123C6.05504 0.227937 6.76843 0 7.5 0C8.23157 0 8.94496 0.227937 9.541 0.652123C9.96562 0.95561 10.4743 1.11918 10.9962 1.12008C11.5181 1.12098 12.0273 0.95915 12.453 0.657123L12.628 0.532123C13.621 -0.177877 15 0.532123 15 1.75212V9.30912H18.5C18.6989 9.30912 18.8897 9.38814 19.0303 9.52879C19.171 9.66945 19.25 9.86021 19.25 10.0591V15.5591C19.25 16.2885 18.9603 16.9879 18.4445 17.5037C17.9288 18.0194 17.2293 18.3091 16.5 18.3091ZM15.25 10.8091V15.5591C15.25 15.8906 15.3817 16.2086 15.6161 16.443C15.8505 16.6774 16.1685 16.8091 16.5 16.8091C16.8315 16.8091 17.1495 16.6774 17.3839 16.443C17.6183 16.2086 17.75 15.8906 17.75 15.5591V10.8091H15.25ZM11 6.55912C11 6.36021 10.921 6.16945 10.7803 6.02879C10.6397 5.88814 10.4489 5.80912 10.25 5.80912H4.25C4.05109 5.80912 3.86032 5.88814 3.71967 6.02879C3.57902 6.16945 3.5 6.36021 3.5 6.55912C3.5 6.75804 3.57902 6.9488 3.71967 7.08945C3.86032 7.2301 4.05109 7.30912 4.25 7.30912H10.25C10.4489 7.30912 10.6397 7.2301 10.7803 7.08945C10.921 6.9488 11 6.75804 11 6.55912ZM10 9.55912C10 9.36021 9.92098 9.16945 9.78033 9.02879C9.63968 8.88814 9.44891 8.80912 9.25 8.80912H4.25C4.05109 8.80912 3.86032 8.88814 3.71967 9.02879C3.57902 9.16945 3.5 9.36021 3.5 9.55912C3.5 9.75804 3.57902 9.9488 3.71967 10.0895C3.86032 10.2301 4.05109 10.3091 4.25 10.3091H9.25C9.44891 10.3091 9.63968 10.2301 9.78033 10.0895C9.92098 9.9488 10 9.75804 10 9.55912ZM10.25 11.8091C10.4489 11.8091 10.6397 11.8881 10.7803 12.0288C10.921 12.1694 11 12.3602 11 12.5591C11 12.758 10.921 12.9488 10.7803 13.0895C10.6397 13.2301 10.4489 13.3091 10.25 13.3091H4.25C4.05109 13.3091 3.86032 13.2301 3.71967 13.0895C3.57902 12.9488 3.5 12.758 3.5 12.5591C3.5 12.3602 3.57902 12.1694 3.71967 12.0288C3.86032 11.8881 4.05109 11.8091 4.25 11.8091H10.25Z"
                                  fill="white"
                                />
                              </svg>
                              Trip Challan
                            </button>
                          </div>

                        </h2>

                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p>Total Freight</p>{" "}
                          <p>
                            ₹{" "}
                            {/* {transactionList?.freight_summary?.total_freight?.toFixed(
                              2
                            )}{" "} */}
                            {Number(transactionList?.freight_summary?.total_freight || 0).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Advance Freight</p>{" "}
                          <p>
                            ₹{" "}
                            {transactionList?.freight_summary?.advance_freight?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex fstInvers_tab">
                          <p>{`Claim > Pay Supplier`}</p>{" "}
                          <p>
                            {`₹ ${transactionList?.freight_summary?.payble
                              ? transactionList?.freight_summary?.payble?.toFixed(
                                2
                              )
                              : (0).toFixed(
                                2
                              )
                              }`}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>{`Claim > Charge Supplier`}</p>{" "}
                          <p>
                            ₹{" "}
                            {transactionList?.freight_summary?.receivable?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Balance Freight</p>{" "}
                          <p>
                            ₹{" "}
                            {/* {transactionList?.freight_summary?.balance_freight?.toFixed(
                              2
                            )}{" "} */}
                            {Number(transactionList?.freight_summary?.balance_freight || 0).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Total TDS</p>{" "}
                          <p>
                            ₹{" "}
                            {/* {transactionList?.freight_summary?.total_tds?.toFixed(
                              2
                            )}{" "} */}
                            {Number(transactionList?.freight_summary?.total_tds || 0).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p className="_balaCe">Balance</p>{" "}
                          <p
                            className={
                              transactionList?.freight_summary?.balance >= 0
                                ? "greenFont_cls"
                                : "redFont_cls"
                            }
                          >
                            {" "}
                            ₹{" "}
                            {/* {transactionList?.freight_summary?.balance?.toFixed(
                              2
                            )}{" "} */}
                            {Number(transactionList?.freight_summary?.balance || 0).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          {/* <p className="_balaCe">
                          {transactionList?.freight_summary?.balance?.toFixed(
                            2
                          )} ₹
                        </p> */}
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Other Expense</p>{" "}
                          <p>
                            ₹{" "}
                            {transactionList?.freight_summary?.other_expenses?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Other Receipt</p>{" "}
                          <p>
                            ₹{" "}
                            {transactionList?.freight_summary?.other_receipt?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        {/* <div className="">
                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p className="_balaCe">Total Trip Expenses</p>{" "}
                          <p className="_balaCe">
                            {transactionList?.freight_summary?.trip_charges?.toFixed(
                              2
                            )}
                          </p>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="anvFreight_smry_tpBx">
                      <div className="anvFreight_smrySticky">
                        <h2 style={{ minHeight: "44px" }}>
                          Freight Summary{" "}

                          <div className="_rSideBtn" >
                            <button className="anime-btn _addComm_btn _builtyPrintBtn" onClick={() => setTripDriverReportShow(true)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="19"
                                viewBox="0 0 20 19"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M16.5 18.3091H3.5C2.57174 18.3091 1.6815 17.9404 1.02513 17.284C0.368749 16.6276 0 15.7374 0 14.8091V1.75212C0 0.685123 1.056 0.00812271 1.985 0.330123C2.118 0.376123 2.248 0.443123 2.372 0.532123L2.547 0.657123C2.97266 0.95915 3.48188 1.12098 4.0038 1.12008C4.52572 1.11918 5.03438 0.95561 5.459 0.652123C6.05504 0.227937 6.76843 0 7.5 0C8.23157 0 8.94496 0.227937 9.541 0.652123C9.96562 0.95561 10.4743 1.11918 10.9962 1.12008C11.5181 1.12098 12.0273 0.95915 12.453 0.657123L12.628 0.532123C13.621 -0.177877 15 0.532123 15 1.75212V9.30912H18.5C18.6989 9.30912 18.8897 9.38814 19.0303 9.52879C19.171 9.66945 19.25 9.86021 19.25 10.0591V15.5591C19.25 16.2885 18.9603 16.9879 18.4445 17.5037C17.9288 18.0194 17.2293 18.3091 16.5 18.3091ZM15.25 10.8091V15.5591C15.25 15.8906 15.3817 16.2086 15.6161 16.443C15.8505 16.6774 16.1685 16.8091 16.5 16.8091C16.8315 16.8091 17.1495 16.6774 17.3839 16.443C17.6183 16.2086 17.75 15.8906 17.75 15.5591V10.8091H15.25ZM11 6.55912C11 6.36021 10.921 6.16945 10.7803 6.02879C10.6397 5.88814 10.4489 5.80912 10.25 5.80912H4.25C4.05109 5.80912 3.86032 5.88814 3.71967 6.02879C3.57902 6.16945 3.5 6.36021 3.5 6.55912C3.5 6.75804 3.57902 6.9488 3.71967 7.08945C3.86032 7.2301 4.05109 7.30912 4.25 7.30912H10.25C10.4489 7.30912 10.6397 7.2301 10.7803 7.08945C10.921 6.9488 11 6.75804 11 6.55912ZM10 9.55912C10 9.36021 9.92098 9.16945 9.78033 9.02879C9.63968 8.88814 9.44891 8.80912 9.25 8.80912H4.25C4.05109 8.80912 3.86032 8.88814 3.71967 9.02879C3.57902 9.16945 3.5 9.36021 3.5 9.55912C3.5 9.75804 3.57902 9.9488 3.71967 10.0895C3.86032 10.2301 4.05109 10.3091 4.25 10.3091H9.25C9.44891 10.3091 9.63968 10.2301 9.78033 10.0895C9.92098 9.9488 10 9.75804 10 9.55912ZM10.25 11.8091C10.4489 11.8091 10.6397 11.8881 10.7803 12.0288C10.921 12.1694 11 12.3602 11 12.5591C11 12.758 10.921 12.9488 10.7803 13.0895C10.6397 13.2301 10.4489 13.3091 10.25 13.3091H4.25C4.05109 13.3091 3.86032 13.2301 3.71967 13.0895C3.57902 12.9488 3.5 12.758 3.5 12.5591C3.5 12.3602 3.57902 12.1694 3.71967 12.0288C3.86032 11.8881 4.05109 11.8091 4.25 11.8091H10.25Z"
                                  fill="white"
                                />
                              </svg>
                              Trip Challan
                            </button>
                          </div>

                        </h2>

                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p>Trip Expense (Payable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹ {Number(transactionList?.freight_summary?.expenses || 0).toFixed(2)}
                          </p>

                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Trip Receipt (Receivable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹ {Number(transactionList?.freight_summary?.receipt || 0).toFixed(2)}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Fastag Auto  </p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹ {Number(transactionList?.freight_summary?.fastag || 0).toFixed(2)}
                          </p>

                        </div>
                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p className="_balaCe">Trip Charges</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}
                            className={
                              transactionList?.freight_summary?.total_freight >=
                                0
                                ? "greenFont_cls"
                                : "redFont_cls"
                            }
                          >
                            {" "}
                            ₹{" "}
                            {transactionList?.freight_summary?.total_freight?.toFixed(
                              2
                            )}{" "}
                          </p>
                          {/* <p className="_balaCe">
                          {transactionList?.freight_summary?.total_freight?.toFixed(
                            2
                          )} ₹
                        </p> */}
                        </div>
                        <div className="anvFr_sumPara_flex ">
                          <p>Driver Claim Charged (Receivable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }} className="_balaCe">
                            ₹{" "}
                            {transactionList?.freight_summary?.receivable?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Driver Claim Paid (Payable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹{" "}
                            {transactionList?.freight_summary?.payble?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p className="_balaCe">Driver Claims</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}
                            className={
                              transactionList?.freight_summary?.receivable -
                                transactionList?.freight_summary?.payble >=
                                0
                                ? "greenFont_cls"
                                : "redFont_cls"
                            }
                          >
                            {" "}
                            ₹{" "}
                            {(
                              (transactionList?.freight_summary?.receivable ||
                                0) -
                              (transactionList?.freight_summary?.payble || 0)
                            )?.toFixed(2)}{" "}
                          </p>
                          {/* <p className="_balaCe">
                          {(
                            transactionList?.freight_summary?.receivable -
                            transactionList?.freight_summary?.payble
                          )?.toFixed(2)} ₹
                        </p> */}
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Other Expense (Payable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹{" "}
                            {transactionList?.freight_summary?.other_expenses?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>
                        <div className="anvFr_sumPara_flex">
                          <p>Other Receipt (Receivable)</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}>
                            ₹{" "}
                            {transactionList?.freight_summary?.other_receipt?.toFixed(
                              2
                            )}{" "}
                          </p>
                        </div>

                        <div className="anvFr_sumPara_flex to_inversTab">
                          <p className="_balaCe">Other Charges</p>{" "}
                          <p style={{ whiteSpace: "nowrap" }}
                            className={
                              transactionList?.freight_summary?.other_receipt -
                                transactionList?.freight_summary
                                  ?.other_expenses >=
                                0
                                ? "greenFont_cls"
                                : "redFont_cls"
                            }
                          >
                            {" "}
                            ₹{" "}
                            {(
                              (transactionList?.freight_summary
                                ?.other_receipt || 0) -
                              (transactionList?.freight_summary
                                ?.other_expenses || 0)
                            )?.toFixed(2)}{" "}
                          </p>

                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )
          )}
        </div>
      </div>

      {/* //-----Market-------- */}

      {isOpenTotal && <AddTotalFreightModal {...addTotalProps} />}
      {/* {isOpenFreight?.open && <FreightPayModal {...freightpayProps} />} */}

      {isOpenFreight?.open && <FreightAdvancePay {...freightpayProps} />}
      {isOpenExpense.open && <OtherExpenseModal {...otherExpenseProps} />}
      {isOpenFuel.open && <AddFuelModal {...fuelProps} />}

      {isOpenSelectLr && <SelectLrForClaimCanves {...selectLrProps} />}
      {isOpenClaim && <ClaimCanvas {...claimProps} />}

      {/* //-----own-------- */}

      {tripChargesOpen && <AddOwnChargesModal {...chargesProps} />}
      {tripMultiExpeOpen && <AddMultiExpenseModal {...multiExpenseProps} />}
      {isOpenOwnClaim && <AddOwnClaimModal {...ownclaimProps} />}
      {isOpenOwnExpense.open && (
        <OtherOwnChargesModal {...otherOwnExpenseProps} />
      )}
      {isOpenPayDriver && <PayDriver {...payDriverProps} />}
      {showFuelOut && <FuelOutModal {...fuelOutProps} />}

      {showAttachedModal?.open && <AttachedFileModal {...attachedModal} />}
      {canvasOpen && <BankListCanvas {...bankListProps} />}
      {showAddBank && <AddBankAccount {...firstAddBank} />}
      {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}
      {isProcessing && <PaymentProcessingOffcanvas
        isOpen={isProcessing}
        message="Please wait while we process your transaction..."
        paymentResult={paymentResult}
        eaesbuzzId={eaesbuzzId}
        onClose={() => {
          setIsProcessing(false)
          setIsOpenPayNow(false)
          setIsOpenFreight({ open: false, type: "" });
        }}
      />}

      {isMakeStatusOpen && <PaymentStatusCard isOpen={isMakeStatusOpen}
        onClose={() => setIsMakeStatusOpen(false)}
        paymentData={paymentData}
        details={{ _id: paymentData?.data?.voucher_id }}
        onShareReceipt={onShareReceipt}
        viewReceiptHandle={viewReceiptHandle}
        doneHandle={doneHandle}
      />}

      {/* <div className={isProcessing ? "offBack_drop" : ""}></div> */}
      {isSuccessOpen && <PaymentSuccessOffcanvas
        isOpen={isSuccessOpen}
        onClose={() => setIsSuccessOpen(false)}
        paymentData={paymentData}
        onDownloadReceipt={handleDownloadReceipt}
        onContactUs={() => alert('Contact support')}
      />}
      <div className={isSuccessOpen ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasDriver ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasDriver ? "visible" : "hidden" }}
      >
        {showOffcanvasDriver && (
          <AddEditMarketDriver
            isOpen={showOffcanvasDriver}
            onClose={(e) => {
              setShowOffcanvasDriver(false);
              setAddDriverShow(true);
            }}
            callBackDriver={callBackDriver}
            hideAddNewOption={false}
            branchFirmId={tripDetais?.firm_id}
          />
        )}
      </div>

      <div className={showOffcanvasDriver ? "offBack_drop" : ""}></div>

      {addDriverShow && (
        <ConfirmModalFor {...addDriverprops}>
          <>
            <div className="colFlx">

              <CityDropdownForTrip
                label={"Driver"}
                placeholder="Select Driver"
                fetchData={fetchDriver}
                pageSize={20}
                onChange={(data) => {
                  // handleOnChange("driver_id", data);
                  setForm({
                    ...form,
                    driver_id: data,
                  });

                  if (formError?.driver_id?._id) {
                    setFormError({ ...formError, driver_id: null });
                  }
                }


                }

                selectedItem={form?.driver_id ? form?.driver_id : { label: "", value: "" }}
                isAddButton={true}
                addButtonAction={addDriverHandle}
                error={!!formError.driver_id}
                errorMessage={formError.driver_id}

              />
            </div>
          </>
        </ConfirmModalFor>
      )}

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              {" "}
              Are you sure you want to delete " {"Transaction"} "{" "}
            </p>
          </>
        </ConfirmModalFor>
      )}

      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
      {tripReportShow
        && (
          <SupplierTripReport {...TripReoprtModal} />
        )
      }
      {tripDriverReportShow
        && (
          <DriverTripReport {...driverTripReoprtPrps} />
        )
      }
    </div>
  );
};

export default Freight;
